import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { BrandViewModel } from '../../business-entities/brand-view-model';
import { UserDealersModel } from '../../business-entities/dealer-details.model';
import { RentalCarList } from '../../business-entities/rental-carList.interface';
import { SelectListItemViewModel } from '../../business-entities/select-list-item-view-model';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { BrandService } from '../../business-services/brand.service';
import { DashboardService } from '../../business-services/dashboard.service';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { CustomPaggerService } from './../../../../../Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdSortableHeader, SortEvent} from './../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from './../../../../../Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from './../../../../../Autofacets-Core/src/app/utils/constant';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { RentalCarService } from './../../business-services/rental-car.service';
import { AddRentalCarComponent } from './add-rental-car/add-rental-car.component';
import { EditRentalCarComponent } from './edit-rental-car/edit-rental-car.component';
import { AdminCommonService } from '../../services/admin-common.service';

@Component({
  selector: 'app-rental-car',
  templateUrl: './rental-car.component.html',
  styleUrls: ['./rental-car.component.css']
})
export class RentalCarComponent implements OnInit, OnDestroy {
  rentalCarList: RentalCarList[];
  popupCloseResult = false;
  total$: Observable<number>;
  paginationSub: Subscription;
  dealerList: Array<SelectListItemViewModel>;
  dealerId: string = '';
  focus$ = new Subject<string>();
  selectedDealerId: string = '';
  selectedDealerIds: string = '';
  dealerSelected: string = '';
  userRoleRightsDetails: UserRoleMenu;
  brandList: BrandViewModel[];
  licensePlateClass: string;
  StatusList: StatusViewModel[] = [];
  selectedStatus: number;

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private rentalCarService: RentalCarService,
    private spinner: NgxSpinnerService,
    public dealerBusinessService: DealerBusinessService,
    private toastr: ToastrService,
    public pService: CustomPaggerService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private userService: UserDataService,
    private brandService: BrandService,
    private globalSetting: GlobalSetting,
    private dashboardService: DashboardService,
    private adminCommonService :AdminCommonService,
    config: NgbModalConfig
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['licensePlatNo', 'model', 'dealerName', 'fuel'];
    this.pService.searchTerm = '';
    config.backdrop = 'static';
    config.keyboard = false;
  }
  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
    this.dashboardService.isFromDashboard = false;
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnInit(): void {
    if (this.dashboardService.isFromDashboard) {
      this.selectedStatus = Enums.StatusCode.Active;
    }
    let status = 0;
    if (this.selectedStatus != undefined) {
      status = this.selectedStatus;
    }
    this.StatusList = this.dashboardService.getStatusList();
    this.getBrands()
    this.getUserDealers();
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.pService.dataSource = [];
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.RentalVehicle);
    this.checkId(status);
  }
  async getUserDealers() {
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
      this.rentalCarService.dealerList = this.dealerList;
    })
  }
  mapdealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {

      for (const item of array) {
        let single = {
          value: item.dealerId,
          text: item.dealerName
        };
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  checkId(status:number) {
    if ((this.rentalCarService.isEdit || this.rentalCarService.isAdd) && this.rentalCarService.dealerId) {
      this.dealerSelected = this.dealerList.find(x => x.value == this.rentalCarService.dealerId).text;
      this.rentalCarService.isEdit = false;
      this.rentalCarService.isAdd = false;
    }
    else {
      this.rentalCarService.dealerId = '';
    }
    this.GetRentalCarList(this.rentalCarService.dealerId,status);
  }
  StatusChange(status: number) {
    if (status == undefined) {
      status = Enums.StatusCode.All;
    }
    this.GetRentalCarList(this.dealerId, status);
  }

  GetRentalCarList(dealerId: string, status: number) {
    this.spinner.show();
    let Id = dealerId ?? '';
    let statusId = status ?? 0 ;
    this.rentalCarService.GetRentalCarList(Id,statusId).then(response => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.pService.dataSource = response.responseObject;
        this.paginationSub = this.pService.dealers$.subscribe(result => {
          this.rentalCarList = this.RentalCarDataMapper(result);
        });
        this.total$ = this.pService.total$;
        this.spinner.hide();
      } else if (
        response.responseObject &&
        response.responseObject.errorCount > 0
      ) {
        if (
          response.responseObject.result &&
          response.responseObject.result.errorCode ===
          Enums.ErrorCodes.ServiceCategoriesCode
        ) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }

  onDealerSelected(dealerId: string) {
    this.selectedDealerId = dealerId ?? '' ;
    this.dealerId = dealerId;
    this.rentalCarService.dealerId = dealerId;
    this.dealerId = dealerId;
    let status = 0;
    if (this.selectedStatus != undefined) {
      status = this.selectedStatus;
    }
    this.GetRentalCarList(this.rentalCarService.dealerId,status);
  }

  onAdd() {
    this.rentalCarService.isAdd = true;
    const modalref = this.modalService.open(AddRentalCarComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  onEdit(rentalCar: any) {
    this.rentalCarService.isEdit = true;
    this.rentalCarService.RentalCarId = rentalCar.id;
    const modalref = this.modalService.open(EditRentalCarComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  private RentalCarDataMapper(carList: any) {
    let supperArray = [];
    if (carList && carList.length > 0) {
      for (let index = 0; index < carList.length; index++) {
        const element = carList[index];

        let single = Object();
        single.rowNumber = this.adminCommonService.currentPageNumber(index);
        single.licensePlatNo = element.licensePlatNo;
        single.engineNo = element.engineNo;
        single.id = element.id;
        single.model = element.model;
        single.company = element.company;
        single.color = element.color;
        single.chessisNo = element.chessisNo;
        single.dealerName = element.dealerName;
        single.fuel = element.fuel;
        single.dealerId = element.dealerId;
        single.year = element.year;
        single.logo = element.logo;
        single.isActive = element.isActive;
        single.image =
          element.rentalCarImage === null
            ? './../../../assets/images/no-img.png'
            : element.rentalCarImage;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  getBrands() {
    this.brandService.getBrand().then(res => {
      if (res) {
        this.brandList = res;
      }
    }
    )
  }

  getBrandImage(key: any) {
    return this.brandList.filter(x => x.brandCode.toUpperCase() === key.toUpperCase())[0]
  }

  deleteRentalCar(id: number) {
    let modelHeadermsg = this.translate.instant('lblDelete');
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblRentalCars"),true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then(
      _result => { },
      reason => {
        this.popupCloseResult = this.adminCommonService.getDismissReason(reason);
        if (this.popupCloseResult) {
          this.rentalCarService.DeleteRentalCar(id).then(response => {
            if (response.responseCode == Constant.SuccessResponseCode) {
              let deletedmsg = this.translate.instant('lblDeletedRentalCar');
              this.toastr.success(deletedmsg);
              this.GetRentalCarList(this.selectedDealerIds,this.selectedStatus);
            }
          });
        }
      }
    );
  }

 
}
